import React from 'react';
import './Loading.css';

/**
 * Loading Component
 * Modern multi-ring spinner with optional text and layout modes
 */
const Loading = ({
  size = 'md', // sm, md, lg
  text = 'Loading...',
  fullPage = false,
  overlay = false,
  className = ''
}) => {
  const containerClassNames = [
    'overview-loader-container',
    fullPage ? 'loading-fullpage' : '',
    overlay ? 'loading-overlay' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClassNames}>
      <div className={`overview-modern-spinner spinner-${size}`}>
        <div className="overview-spinner-ring"></div>
        <div className="overview-spinner-ring"></div>
        <div className="overview-spinner-ring"></div>
      </div>
      
      {text && (
        <div className="overview-loader-content">
          <p>{text}</p>
        </div>
      )}
    </div>
  );
};

export default Loading;